import type { SVGProps } from 'react';

const SvgClassBj = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26676)'>
      <path
        d='M19.1683 24H12.8317C5.74496 24 0 18.6274 0 12C0 5.37261 5.74496 0 12.8317 0H19.1683C26.255 0 32 5.37258 32 12C32 18.6274 26.255 24 19.1683 24Z'
        fill='#FF9912'
      />
      <path
        d='M24.9282 13.9846C24.9282 16.1841 23.2201 17.3391 20.9997 17.3391C18.7922 17.3391 17.1104 16.1841 17.1104 13.9599C17.1104 13.3578 17.6225 12.9769 18.28 12.9769C18.9366 12.9769 19.4487 13.3578 19.4487 13.9599C19.4487 14.734 20.0272 15.3731 21.0125 15.3731C21.985 15.3731 22.5626 14.734 22.5626 13.9599V7.70569C22.5626 7.06665 23.0884 6.66113 23.7458 6.66113C24.4024 6.66113 24.9282 7.06664 24.9282 7.70569L24.9282 13.9846Z'
        fill='white'
      />
      <path
        d='M14.5078 11.8344C15.2043 11.5027 15.7819 10.7163 15.7819 9.79451C15.7819 7.97627 14.3761 6.82129 12.3002 6.82129H8.38445C7.59621 6.82129 7.07129 7.31259 7.07129 8.04974V15.8649C7.07129 16.602 7.59622 17.0933 8.38445 17.0933H12.6026C14.8229 17.0933 16.0579 15.8649 16.0579 14.0585C16.0579 13.1248 15.5321 12.1537 14.5078 11.8344ZM12.4845 15.1766H9.40968V8.73804H12.2085C12.9967 8.73804 13.4435 9.24166 13.4435 9.8807C13.4435 10.5074 12.9967 11.0234 12.2085 11.0234H11.2777V12.842H12.4845C13.2591 12.842 13.7458 13.3579 13.7458 14.0216C13.7458 14.673 13.2591 15.1766 12.4845 15.1766Z'
        fill='white'
      />
      <path
        d='M11.3966 12.8427C11.9339 12.8427 12.3694 12.4354 12.3694 11.9329C12.3694 11.4305 11.9339 11.0232 11.3966 11.0232C10.8594 11.0232 10.4238 11.4305 10.4238 11.9329C10.4238 12.4354 10.8594 12.8427 11.3966 12.8427Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26676'>
        <rect width={32} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassBj;
